import React from "react";
import { useTranslation } from "react-i18next";

import { BetOffer } from "@models";

export default function EventScoreAtBetTime(props: { offer: BetOffer }) {
	const { t } = useTranslation("mybets");

	const liveString = props.offer.isLive ? `*${t("ITEM.LIVE_SCORE")}*` : "";

	return (
		<div className="table--bet__body__data--event--live table--bet__body__data--event--live">
			<div className="u-type--tny u-type--case--uppercase">
				{liveString} {props.offer.formattedResultAtBetTime}
				{props.offer.scorePerPeriodAtBetTimeString}
			</div>
		</div>
	);
}
